import {
    RESET_PASSWORD_OPEN_MODAL,
    RESET_PASSWORD_CLOSE_MODAL,
    RESET_PASSWORD_REQUEST,
    RESET_PASSWORD_RESULT,
    CLEAR_REDUX,
} from "Redux/actionTypes";

const INIT_STATE = {
    openModal: false,
    loading: false,
    passwordResult: null,
    entity: null,
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case RESET_PASSWORD_OPEN_MODAL:
            return { ...state, openModal: true, entity: action.payload }

        case RESET_PASSWORD_CLOSE_MODAL:
            return { ...state, openModal: false }

        case RESET_PASSWORD_REQUEST:
            return { ...state, loading: true }

        case RESET_PASSWORD_RESULT:
            return { ...state, loading: false, passwordResult: action.payload }

        case CLEAR_REDUX:
            return ["", "RESET_PASSWORD"].includes(action.payload.option)
                ? action.payload.parameters ? { ...state, ...action.payload.parameters } : { ...INIT_STATE }
                : { ...state }
        default:
            return state;
    }
};